import { t } from 'i18next';
import React from 'react';
import { Card } from 'react-bootstrap';

const FaqAdminguide = () => {
  return (
    <div>
      <h3 className="mb-4">{t('header.text.text_17')}</h3>
      <Card>
        <Card.Body>
          <iframe
            src="https://docs.google.com/document/d/1pofPfnTnAdS0iNLPDHdXMD2lfj8_kFPPMygNRoB3718/preview"
            style={{ width: '100%', height: '600px', border: 'none' }}
            title="Admin Guide"
          ></iframe>
        </Card.Body>
      </Card>
    </div>
  );
};

export default FaqAdminguide;
